import React, { useState } from "react";
import { Select } from "antd";
import { Button, Message, Spin, Input } from "../../../BP2Components";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { getListStructure } from "services/api/Api";
import { useIntl } from "react-intl";

const { Option } = Select;

const TimeLineSettings = (props) => {
   const { value, columns } = props;
   const dispatch = useDispatch();
   const intl = useIntl();

   const [settings, setSettings] = useState({
      ...value,
      columns
   });

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };
   const handleChangeList = (e) => {
      getListStructure(settings.listId).then((res) => {
         const responseData = res.data.getStructure;
         if (responseData.columns !== undefined && responseData.columns !== null) {
            setSettings({
               ...settings,
               columns: responseData.columns
            });
         }
      });
   };
   const handleChange = (e) => {
      setSettings({ ...settings, [e.target.name]: e.target.value });
   };
   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };

   const handleChangeSelect = (name) => (value) => {
      setSettings({ ...settings, [name]: value });
   };

   const options =
      settings && settings.columns !== undefined ? (
         settings.columns.map((col) => (
            <Option key={col.label} value={col.label}>
               {col.label}
            </Option>
         ))
      ) : (
         <Spin />
      );

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="Set" className="widget-settings__inner">
                  <label key="title" className="widget-settings__inner__label">
                     <IntlMessages id="settings.listId" />:
                     <div style={{ display: "flex" }}>
                        <Input
                           type="text"
                           name="listId"
                           defaultValue={value.listId}
                           onChange={handleChange}
                           style={{ width: "100px" }}
                        />
                        <Button className="gx-ml-1" buttonType="primary" onClick={handleChangeList}>
                           <IntlMessages id="settings.changeId" />
                        </Button>
                     </div>
                  </label>
                  <label key="itemsPerWidget" className="widget-settings__inner__label">
                     <IntlMessages id="settings.itemsPerWidget" />:
                     <Input
                        type="number"
                        name="itemsPerWidget"
                        onChange={handleChangeInput("itemsPerWidget")}
                        min={1}
                        style={{ width: "100px" }}
                        defaultValue={value.itemsPerWidget}
                     />
                  </label>
                  <label
                     key="dateAttribute"
                     name="dateAttribute"
                     className="widget-settings__inner__label"
                  >
                     <IntlMessages id="settings.dateAttribute" />:
                     <Select
                        key="dateAttribute"
                        name="dateAttribute"
                        style={{ width: 220 }}
                        onChange={handleChangeSelect("dateAttribute")}
                     >
                        {options}
                     </Select>
                  </label>
                  <label key="titleAttribute" className="widget-settings__inner__label">
                     <IntlMessages id="settings.titleAttribute" />:
                     <Select
                        key="titleAttribute"
                        name="titleAttribute"
                        style={{ width: 220 }}
                        onChange={handleChangeSelect("titleAttribute")}
                     >
                        {options}
                     </Select>
                  </label>
                  <label key="descriptionAttribute" className="widget-settings__inner__label">
                     <IntlMessages id="settings.descriptionAttribute" />:
                     <Select
                        key="descriptionAttribute"
                        name="descriptionAttribute"
                        style={{ width: 220 }}
                        onChange={handleChangeSelect("descriptionAttribute")}
                     >
                        {options}
                     </Select>
                  </label>
                  <label key="iconAttribute" className="widget-settings__inner__label">
                     <IntlMessages id="settings.iconAttribute" />
                     <Input
                        type="iconAttribute"
                        name="iconAttribute"
                        defaultValue={settings.iconAttribute}
                        onChange={handleChange}
                        style={{ width: "220px" }}
                     />
                  </label>
                  <label key="noDataInfoTranslationKey" className="widget-settings__inner__label">
                     <IntlMessages id="settings.noDataInfoTranslationKey" />:
                     <Input
                        type="noDataInfoTranslationKey"
                        name="noDataInfoTranslationKey"
                        defaultValue={settings.noDataInfoTranslationKey}
                        onChange={handleChange}
                        style={{ width: "220px" }}
                     />
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default TimeLineSettings;
